// Site-wide configuration constants
export const SITE_CONFIG = {
  name: 'KOA DETAILING',
  nameKo: 'KOA DETAILING',
  tagline: '프리미엄 스팀 손세차',
  phone: '010-3931-4528',
  kakaoChannelId: '_aPqxkn',
  address: '경기도 수원시 곡반정로 93',
  // 매장 좌표 — 모바일 지도 앱(티맵 등)에 길안내 destination 좌표로 사용. JSON-LD geo와 동일 값.
  coords: { lat: 37.236659, lng: 127.030017 },
  // Business hours (changed 2026-05-27): Tue-Sat 10:00-19:00 (closed-day note removed; weekdays unchanged)
  hours: {
    open: '10:00 - 19:00',
    openDays: '화 - 토',
    summary: '화-토 10:00 - 19:00',
  },
  // Business registration info - legal disclosure (전자상거래법)
  business: {
    companyName: 'KOA',
    representative: '유지남',
    registrationNumber: '451-88-03839',
    businessAddress: '경기도 수원시 곡반정로 93',
    privacyOfficer: {
      name: '유지남',
      title: '대표',
      phone: '010-3931-4528',
    },
  },
};

// External Naver booking URL (verified 2026-05-27). Change in one place if Naver URL ever updates.
export const NAVER_BOOKING_URL =
  'https://booking.naver.com/booking/6/bizes/1660513/items/7715136?area=pll&lang=ko&service-target=map-pc&theme=place';

// External Naver blog URL (post link set 2026-06-08). Points to a specific post; was the blog home (koreaonauto).
export const NAVER_BLOG_URL = 'https://blog.naver.com/koreaonauto/224303031654';
